import { useCallback, useState } from 'react';

const OPEN_KEY = 'ss-tutor-open';

/** Tutor aberto ou recolhido, lembrado entre páginas. Em telas largas começa aberto. */
export function useTutorOpen() {
  const [open, setOpen] = useState(() => {
    try {
      const v = localStorage.getItem(OPEN_KEY);
      if (v != null) return v === '1';
    } catch { /* sem storage */ }
    return window.innerWidth >= 1280;
  });
  const set = useCallback((v) => {
    setOpen(v);
    try { localStorage.setItem(OPEN_KEY, v ? '1' : '0'); } catch { /* sem storage */ }
  }, []);
  return [open, set];
}

/**
 * Leva até a fonte citada pelo tutor, depois que a aba trocou:
 * "Resumo §2" → 2º título de seção; "Transcrição 04:12" → a marca [04:12] (ou a mais próxima antes).
 */
export function goToSource(containerRef, label) {
  setTimeout(() => {
    const root = containerRef.current;
    if (!root) return;
    let target = null;
    const time = /(\d{1,2}):(\d{2})/.exec(label);
    const section = /§\s*(\d+)/.exec(label);
    if (time) {
      const want = Number(time[1]) * 60 + Number(time[2]);
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let best = null;
      while (walker.nextNode()) {
        const node = walker.currentNode;
        for (const m of node.textContent.matchAll(/\[(\d{1,2}):(\d{2})\]/g)) {
          const t = Number(m[1]) * 60 + Number(m[2]);
          if (t <= want && (!best || t >= best.t)) best = { t, node, index: m.index, len: m[0].length };
        }
      }
      if (best) {
        const range = document.createRange();
        range.setStart(best.node, best.index);
        range.setEnd(best.node, best.index + best.len);
        const rect = range.getBoundingClientRect();
        window.scrollTo({ top: rect.top + window.scrollY - 140, behavior: 'smooth' });
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        return;
      }
    } else if (section) {
      const n = Number(section[1]);
      const heads = root.querySelectorAll('.ss-markdown h2, .lesson-reading h2, h2:not(.lesson-body__head h2)');
      const list = [...heads].filter(h => !h.closest('.lesson-body__head'));
      // Texto antes do primeiro "##" conta como §1 quando existe
      const intro = list[0] && list[0].previousElementSibling ? 1 : 0;
      target = list[n - 1 - intro] || list[n - 1] || null;
    }
    (target || root).scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (target) {
      target.classList.add('ai-flash');
      setTimeout(() => target.classList.remove('ai-flash'), 1600);
    }
  }, 60);
}
